import checkout from "./form038C";

const {
  formField038C: { totalTaxTNDN, totalExpense },
} = checkout;

const initialValues038C = {
  [totalTaxTNDN.name]: "",
  [totalExpense.name]: "",
};

export default initialValues038C;
